export const WpformsTypeDecorator = {
  url() {
    return `signup-hubspot/integrations`;
  },

  query() {
    return {
      integration: `wpforms`
    };
  }

};